export type SeoFaq = {
  answer: string;
  question: string;
};

export type SeoSection = {
  body: string;
  bullets?: string[];
  title: string;
};

export type SeoPageConfig = {
  canonicalUrl: string;
  ctaBody: string;
  ctaTitle: string;
  description: string;
  faqs?: SeoFaq[];
  heading: string;
  intro: string;
  kicker: string;
  path: string;
  sections: SeoSection[];
  shortLabel: string;
  title: string;
};

export const APK_DOWNLOAD_HREF =
  import.meta.env.VITE_APK_DOWNLOAD_URL?.trim() || "/AR_Drawing_Master_v2.9_final_updated.apk";

export const APK_VERSION_LABEL = "Android APK 2.9";
export const APK_SIZE_LABEL = "83.2 MB";

export const seoPages: SeoPageConfig[] = [
  {
    path: "/download",
    shortLabel: "Download",
    title: "Download AR Drawing Master APK for Android",
    description:
      "Download the latest AR Drawing Master APK for Android. Install the app directly, trace on real paper with AR guidance, and start drawing with templates and AI ideas.",
    canonicalUrl: "https://ardrawingmaster.online/download",
    kicker: "APK Download",
    heading: "Download AR Drawing Master APK for Android.",
    intro:
      "This page gives you the direct installer for AR Drawing Master and explains what you get inside the Android app before you install it.",
    sections: [
      {
        title: "What the app does",
        body:
          "AR Drawing Master helps you trace on real paper with guided overlays, explore ready-made template categories, and turn ideas or photos into sketch references faster.",
      },
      {
        title: "What to expect before installing",
        body:
          "The website is a product and download hub. The full tracing, template, camera, and AI-assisted workflows run inside the Android APK after installation.",
        bullets: [
          "Direct APK download from this domain.",
          "Android-focused app experience.",
          "Templates, text art, camera tracing, and guided practice flows inside the app.",
        ],
      },
      {
        title: "How to install",
        body:
          "Download the APK, open it from your browser or downloads folder, allow installation when Android prompts you, then launch the app and begin tracing.",
      },
    ],
    ctaTitle: "Ready to install?",
    ctaBody:
      "Use the direct download button to get the current Android build of AR Drawing Master.",
    faqs: [
      {
        question: "Is this a direct APK download?",
        answer: "Yes. The download button points directly to the latest AR Drawing Master APK package.",
      },
      {
        question: "Does the website run the full app?",
        answer: "No. The website explains the product and hosts the installer. The full drawing experience runs in the Android app.",
      },
    ],
  },
  {
    path: "/features/ar-tracing",
    shortLabel: "AR Tracing",
    title: "AR Tracing Feature for Real Paper Drawing",
    description:
      "Learn how AR Drawing Master uses AR tracing to project guides onto real paper so beginners and hobby artists can practice cleaner sketch lines.",
    canonicalUrl: "https://ardrawingmaster.online/features/ar-tracing",
    kicker: "Feature",
    heading: "AR tracing that keeps your focus on the paper.",
    intro:
      "AR Drawing Master turns your phone into a practical tracing guide so you can line up sketches over real paper and build drawing confidence through repetition.",
    sections: [
      {
        title: "Why AR tracing helps",
        body:
          "Instead of guessing proportions from a tiny reference, you get a live visual guide that helps you place lines more consistently and practice hand control.",
        bullets: [
          "Better line placement on real paper.",
          "Less friction for beginners who want to practice daily.",
          "Cleaner tracing flow than jumping between gallery and sketchbook.",
        ],
      },
      {
        title: "Who this is for",
        body:
          "This mode is useful for beginner artists, hobby sketchers, and anyone who wants a faster way to study outlines, forms, and composition on paper.",
      },
      {
        title: "How it fits the app",
        body:
          "AR tracing works alongside templates, image import, and idea generation so you can move from inspiration to practice without switching tools.",
      },
    ],
    ctaTitle: "Try the AR tracing workflow",
    ctaBody:
      "Install the Android app to use the real-paper tracing experience inside AR Drawing Master.",
  },
  {
    path: "/ar-tracing-app",
    shortLabel: "Tracing App",
    title: "AR Tracing App for Android Drawing Practice",
    description:
      "Discover an AR tracing app for Android that helps you draw on real paper with guided overlays, templates, and a simpler beginner practice workflow.",
    canonicalUrl: "https://ardrawingmaster.online/ar-tracing-app",
    kicker: "Keyword Guide",
    heading: "An AR tracing app built for drawing on real paper.",
    intro:
      "If you are searching for an AR tracing app, AR Drawing Master is designed around the exact workflow most beginners want: place your phone, align paper, and follow guided overlays while you practice line control.",
    sections: [
      {
        title: "What makes an AR tracing app useful",
        body:
          "The main advantage is speed. Instead of constantly checking a second reference image, you can keep your eyes on the paper and follow a more stable guide while sketching.",
        bullets: [
          "Guided overlays for paper-based drawing.",
          "Useful for beginners who want cleaner proportions.",
          "Faster setup than switching between gallery images and sketchbook.",
        ],
      },
      {
        title: "How AR Drawing Master fits that search",
        body:
          "AR Drawing Master combines tracing guidance with templates, image-based references, and AI-assisted sketch ideas so one app can cover both practice and inspiration.",
      },
      {
        title: "Best use case",
        body:
          "This works best for hobby artists, students, and casual sketchers who want a practical Android drawing app instead of a complicated art toolchain.",
      },
    ],
    ctaTitle: "Try this AR tracing app on Android",
    ctaBody:
      "Download AR Drawing Master to start tracing on real paper with templates and guided overlays.",
  },
  {
    path: "/features/ai-sketch-generator",
    shortLabel: "AI Sketch",
    title: "AI Sketch Generator for Drawing Ideas",
    description:
      "Explore the AI sketch generator in AR Drawing Master to create fresh drawing ideas, convert concepts into sketch references, and keep your practice sessions moving.",
    canonicalUrl: "https://ardrawingmaster.online/features/ai-sketch-generator",
    kicker: "Feature",
    heading: "AI sketch ideas when you run out of references.",
    intro:
      "AR Drawing Master includes an AI-assisted idea flow so you can start from a prompt, generate a concept, and continue into tracing or sketch practice quickly.",
    sections: [
      {
        title: "Why it matters",
        body:
          "A lot of practice sessions stop because people spend too much time hunting for references. An AI sketch generator helps you create a starting point faster.",
      },
      {
        title: "How artists use it",
        body:
          "Generate a simple concept, pick the direction you like, and then move into tracing or refinement inside the same app workflow.",
        bullets: [
          "Faster idea generation for daily drawing.",
          "Less time searching for images.",
          "Useful for beginner prompts and creative warmups.",
        ],
      },
      {
        title: "Best use case",
        body:
          "It works best when you want momentum: create an idea, turn it into a guide, then keep drawing instead of leaving the app to find inspiration elsewhere.",
      },
    ],
    ctaTitle: "Use AI ideas inside the app",
    ctaBody:
      "Download the Android build to explore AI-assisted sketch generation in AR Drawing Master.",
  },
  {
    path: "/features/template-library",
    shortLabel: "Templates",
    title: "Drawing Template Library for Beginners and Hobby Artists",
    description:
      "Browse the AR Drawing Master template library with multiple categories, difficulty levels, and guided sketch references for repeat drawing practice.",
    canonicalUrl: "https://ardrawingmaster.online/features/template-library",
    kicker: "Feature",
    heading: "A drawing template library built for repeat practice.",
    intro:
      "AR Drawing Master gives you a structured template library so you can keep practicing without hunting for new references every time you want to draw.",
    sections: [
      {
        title: "What is inside the library",
        body:
          "The library is organized around multiple themes and drawing styles so you can move between categories without breaking your practice flow.",
      },
      {
        title: "Why templates help beginners",
        body:
          "Templates lower the barrier to starting. You can focus on tracing, line control, and confidence instead of spending energy deciding what to draw.",
        bullets: [
          "More consistent practice sessions.",
          "Faster setup for beginner artists.",
          "Better variety than relying on a single reference source.",
        ],
      },
      {
        title: "How templates connect with other tools",
        body:
          "You can combine templates with AR tracing, imported photos, and idea-generation tools to create a smoother learning loop inside the app.",
      },
    ],
    ctaTitle: "Browse templates in the APK",
    ctaBody:
      "Install AR Drawing Master on Android to access the guided template and category workflow.",
  },
  {
    path: "/how-to-use",
    shortLabel: "How To Use",
    title: "How to Use AR Drawing Master on Android",
    description:
      "Step-by-step guide to using AR Drawing Master on Android, from installing the APK to choosing templates, tracing on paper, and building a beginner drawing routine.",
    canonicalUrl: "https://ardrawingmaster.online/how-to-use",
    kicker: "Guide",
    heading: "How to use AR Drawing Master step by step.",
    intro:
      "If you are new to the app, this page gives you the fastest path from installation to your first tracing session on paper.",
    sections: [
      {
        title: "Step 1: Install the APK",
        body:
          "Download the Android package from this website, open it from your downloads list, and complete installation when Android asks for permission.",
      },
      {
        title: "Step 2: Pick a source",
        body:
          "Start with a template, a photo from your gallery, or an AI-assisted idea so you have a clear drawing target for the session.",
      },
      {
        title: "Step 3: Trace and refine",
        body:
          "Use the phone as a guided overlay, align your paper, and trace in simple passes. Repeat with new templates to improve confidence over time.",
        bullets: [
          "Begin with easy references.",
          "Repeat short sessions often.",
          "Use guided overlays to study proportion and line placement.",
        ],
      },
    ],
    ctaTitle: "Start your first tracing session",
    ctaBody:
      "Download AR Drawing Master and follow the beginner-friendly setup inside the Android app.",
  },
  {
    path: "/drawing-app-apk",
    shortLabel: "App APK",
    title: "Drawing App APK for Android Sketch Practice",
    description:
      "Download a drawing app APK for Android that includes AR tracing, templates, sketch guidance, and beginner-friendly tools for drawing on paper.",
    canonicalUrl: "https://ardrawingmaster.online/drawing-app-apk",
    kicker: "APK Guide",
    heading: "A drawing app APK focused on practical sketch practice.",
    intro:
      "If you are looking for a drawing app APK instead of another generic directory listing, this page explains what AR Drawing Master offers before you install the Android package directly from the official website.",
    sections: [
      {
        title: "What you get in the APK",
        body:
          "The Android package gives you the complete AR Drawing Master experience, including real-paper tracing support, templates, image-based drawing flows, and AI-assisted sketch ideas.",
      },
      {
        title: "Why use the official website download",
        body:
          "The official site gives you a direct app landing page, installation guidance, and supporting product pages instead of sending you through a thin third-party listing.",
        bullets: [
          "Direct APK download from the project website.",
          "Clear feature pages for tracing, templates, and setup help.",
          "Better context before installing the Android package.",
        ],
      },
      {
        title: "Who this is for",
        body:
          "This APK is aimed at Android users who want a sketch practice app with AR help, not a browser drawing tool or a desktop illustration suite.",
      },
    ],
    ctaTitle: "Download the drawing app APK",
    ctaBody:
      "Install AR Drawing Master from the official website and start drawing with guided Android workflows.",
    faqs: [
      {
        question: "Is this page the official APK source for the app?",
        answer: "Yes. This website hosts the direct AR Drawing Master Android package and related setup pages.",
      },
      {
        question: "Does the APK include tracing and templates?",
        answer: "Yes. The Android app includes AR tracing, template browsing, and guided drawing flows designed for beginners and hobby artists.",
      },
    ],
  },
  {
    path: "/apk-download-for-ar-drawing",
    shortLabel: "APK Download",
    title: "APK Download for AR Drawing on Android",
    description:
      "Get an APK download for AR drawing on Android with tracing overlays, templates, and beginner-friendly sketch practice in AR Drawing Master.",
    canonicalUrl: "https://ardrawingmaster.online/apk-download-for-ar-drawing",
    kicker: "Branded APK Page",
    heading: "APK download for AR drawing, straight from the official site.",
    intro:
      "This page is for people searching specifically for an APK download for AR drawing. AR Drawing Master gives you the Android package, installation context, and practical feature overview in one place.",
    sections: [
      {
        title: "Why this page exists",
        body:
          "Many app-related searches land on generic listing sites with very little product context. This page gives you the official download path plus a clearer explanation of what the Android app actually does.",
      },
      {
        title: "What you get after install",
        body:
          "After installing the APK, you can use AR tracing on real paper, explore drawing templates, work from image references, and keep practice sessions moving with AI-assisted sketch ideas.",
        bullets: [
          "Official website download.",
          "Android-focused tracing workflow.",
          "Better context than a bare APK directory listing.",
        ],
      },
      {
        title: "Who should use it",
        body:
          "This is meant for Android users searching for an AR drawing APK, especially beginners and hobby artists who want practical tracing help rather than a complex digital art suite.",
      },
    ],
    ctaTitle: "Download the AR drawing APK",
    ctaBody:
      "Use the direct APK download from AR Drawing Master and start drawing with guided Android workflows.",
    faqs: [
      {
        question: "Is this the official AR Drawing Master APK page?",
        answer: "Yes. This page is part of the official AR Drawing Master website and links to the direct Android package.",
      },
      {
        question: "Does the app work as a browser drawing tool?",
        answer: "No. The website is a product and download portal. The full tracing experience runs inside the Android APK after installation.",
      },
    ],
  },
  {
    path: "/faq",
    shortLabel: "FAQ",
    title: "AR Drawing Master FAQ",
    description:
      "Read common questions about AR Drawing Master, including APK download, how the website works, beginner usage, and what features are available in the Android app.",
    canonicalUrl: "https://ardrawingmaster.online/faq",
    kicker: "FAQ",
    heading: "Frequently asked questions about AR Drawing Master.",
    intro:
      "These are the questions most people ask before installing the app or trying the tracing workflow for the first time.",
    sections: [
      {
        title: "Quick answers before you install",
        body:
          "This page covers the basics: where the APK comes from, whether the website runs the app, and whether the workflow is suitable for beginners.",
      },
    ],
    faqs: [
      {
        question: "Does the website run the full app in browser?",
        answer: "No. The website is a showcase and download portal. The full tracing and drawing tools run inside the Android APK.",
      },
      {
        question: "Is the APK download hosted on this website?",
        answer: "Yes. The download button on this domain links directly to the current AR Drawing Master Android package.",
      },
      {
        question: "Can beginners use AR Drawing Master?",
        answer: "Yes. The workflow is designed for beginner and hobby artists with templates, guided tracing, and repeat practice loops.",
      },
      {
        question: "What kind of features are inside the app?",
        answer: "The Android app includes AR tracing, template browsing, text and image-based sketch workflows, and AI-assisted idea generation.",
      },
    ],
    ctaTitle: "Still ready to try it?",
    ctaBody:
      "Download the APK and explore the beginner-friendly tracing workflow in the Android app.",
  },
];

export const seoPageMap = new Map(seoPages.map((page) => [page.path, page]));
